import React, { useRef } from "react";
import { Carousel } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import config from "../../../config";

const CarouselImageCard = ({ items = [], height = 420 }) => {
  const carouselRef = useRef();

  const next = () => carouselRef.current.next();
  const prev = () => carouselRef.current.prev();

  return (
    <div style={{ position: "relative", width: "100%" }}>
      
      {/* Arrows */}
      <div style={arrowStyle("left")} onClick={prev}>
        <LeftOutlined />
      </div>
      <div style={arrowStyle("right")} onClick={next}>
        <RightOutlined />
      </div>

      <Carousel autoplay dots ref={carouselRef}>
        {items.map((item, index) => {
          const image =
            item.image && item.image.startsWith("http")
              ? item.image
              : config.assetsBasePath + item.image;

          return (
            <div key={index}>
              <a
                href={item.link || "#"}
                target="_blank"
                rel="noopener noreferrer"
                style={{ display: "block" }}
              >
                <div
                  style={{
                    position: "relative",
                    height: height,
                    overflow: "hidden",
                    borderRadius: 16
                  }}
                >
                  {/* Image */}
                  <img
                    src={image}
                    alt={item.title || "banner"}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      transition: "transform 0.6s ease"
                    }}
                  />

                  {/* Dark Gradient Overlay */}
                  <div
                    style={{
                      position: "absolute",
                      inset: 0,
                      background:
                        "linear-gradient(to bottom, rgba(0,0,0,0.2), rgba(0,0,0,0.6))"
                    }}
                  />

                  {/* Center Title (NO button look) */}
                  {item.title && (
                    <div
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        textAlign: "center",
                        width: "80%"
                      }}
                    >
                      <h1
                        style={{
                          fontSize: "42px",
                          fontWeight: 700,
                          color: "#fff",
                          margin: 0,
                          letterSpacing: "1px",
                          textShadow: "0 4px 20px rgba(0,0,0,0.5)"
                        }}
                      >
                        {item.title}
                      </h1>
                    </div>
                  )}

                  {/* Bottom Subtitle */}
                  {item.subtitle && (
                    <div
                      style={{
                        position: "absolute",
                        bottom: 20,
                        left: 30,
                        right: 30,
                        fontSize: "14px",
                        color: "#fff",
                        opacity: 0.9
                      }}
                    >
                      {item.subtitle}
                    </div>
                  )}
                </div>
              </a>
            </div>
          );
        })}
      </Carousel>
    </div>
  );
};

const arrowStyle = (side) => ({
  position: "absolute",
  top: "50%",
  [side]: 25,
  transform: "translateY(-50%)",
  zIndex: 10,
  fontSize: 18,
  color: "#fff",
  background: "rgba(0,0,0,0.45)",
  padding: 12,
  borderRadius: "50%",
  cursor: "pointer",
  backdropFilter: "blur(6px)",
  transition: "all 0.3s ease"
});

export default CarouselImageCard;
